import MainFrame from './components/layouts/MainFrame/MainFrame';
import { Navigate, Route, Routes } from 'react-router-dom';
import RouteGuard from './components/routes/RouteGuard';
import { Login } from './components/routes/Pages/Authentication/Login/Login';
import styled from 'styled-components';
import ModalWrapper from './components/dialogs/modal-wrapper/ModalWrapper';
import { GlobalErrorConfiguration } from './hooks/globalErrorUtils';
import { BootstrapHandler } from './utils/bootstrapHandler';
import { QueryClient, QueryClientProvider } from 'react-query';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import './utils/i18n';
import { Registration } from './components/routes/Pages/Authentication/Registration/Registration';
import { ForgotPassword } from './components/routes/Pages/Authentication/forgot-password/ForgotPassword';
import { SnackbarContent } from './utils/SnackbarUtils';
import { PageWrapper } from './components/routes/Pages/PageWrapper';
import { Profile } from './components/routes/Pages/Profile/Profile';
import { Collections } from './components/routes/Pages/Collections/Collections';
import { ControlPagesWrapper } from './components/routes/Pages/ControlPagesWrapper';
import { CollectionPageWrapper } from './components/routes/Pages/CollectionPageWrapper';
import { ProductPage } from './components/routes/Pages/ProductPage/ProductPage';
import { ContentLayout } from './components/layouts/MainFrame/ContentLayout';
import React from 'react';
import { Invoices } from './components/routes/Pages/Invoices/Invoices';
import { LogoutLandingPage } from './components/routes/Pages/Authentication/Logout/LogoutLandingPage';
import LockGuard from './components/routes/LockGuard';
import { ForgotPasswordLanding } from './components/routes/Pages/Authentication/forgot-password/ForgotPasswordLanding';
import ProfileFrame from './components/layouts/ProfileFrame/ProfileFrame';
import { Quotations } from './components/routes/Pages/Quotations/Quotations';
import {
    SIDEBAR_ADMIN_NAVIGATION,
    SIDEBAR_PROFILE_NAVIGATION,
    SIDEBAR_QUOTATION_NAVIGATION,
} from './utils/constans/SidebarMenu';
import Error404 from './components/routes/Pages/Error404/Error404';
import PDFPreview from './components/routes/Pages/PDFPreview/PDFPreview';
import { Quotation } from './components/routes/Pages/Quotation/Quotation';
import { MyQuotations } from './components/routes/Pages/MyQuotations/MyQuotations';
import { LiveOrders } from './components/routes/Pages/LiveOrders/LiveOrders';
import { Admin } from './components/routes/Pages/Admin/Admin';
import { AdminAddPartner } from './components/routes/Pages/Admin/AdminAddPartner';
import { AdminUsers } from './components/routes/Pages/Admin/AdminUsers';
import { AdminCompanyRequests } from './components/routes/Pages/Admin/AdminCompanyRequests';
import { Cart } from './components/routes/Pages/Cart/Cart';
import { AdminProductsManagement } from './components/routes/Pages/Admin/AdminProductsManagement';

const StyledApp = styled.div`
    background-color: white !important;
    //color: black !important;
`;

export const queryClient = new QueryClient();

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <StyledApp>
                <BootstrapHandler />
                <Provider store={store}>
                    <GlobalErrorConfiguration />
                    <ModalWrapper />
                    <SnackbarContent />
                    <Routes>
                        <Route path={'login'} element={<Login />} />
                        <Route
                            path={'registration'}
                            element={<Registration />}
                        />
                        <Route
                            path={'forgot-password'}
                            element={<ForgotPassword />}
                        />
                        <Route
                            path={'logout'}
                            element={<LogoutLandingPage />}
                        />
                        <Route
                            path={'password-reset/:token/'}
                            element={<ForgotPasswordLanding />}
                        />
                        <Route element={<RouteGuard />}>
                            <Route path={'/'} element={<ProfileFrame />}>
                                <Route
                                    index
                                    element={<Navigate to={'profile'} />}
                                />
                                <Route
                                    path={'profile'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Profile />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'invoices'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Invoices />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'cart'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Cart />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                            </Route>
                            <Route element={<LockGuard />}>
                                <Route path={'/'} element={<ProfileFrame />}>
                                    <Route
                                        path={'admin'}
                                        element={
                                            <PageWrapper>
                                                <ControlPagesWrapper
                                                    sidebarItems={
                                                        SIDEBAR_ADMIN_NAVIGATION
                                                    }
                                                >
                                                    <Admin />
                                                </ControlPagesWrapper>
                                            </PageWrapper>
                                        }
                                    >
                                        <Route
                                            path={'add-partner'}
                                            element={<AdminAddPartner />}
                                        />
                                        <Route
                                            path={'users'}
                                            element={<AdminUsers />}
                                        />
                                        <Route
                                            path={'company-requests'}
                                            element={<AdminCompanyRequests />}
                                        />
                                        <Route
                                            path={'products-management'}
                                            element={
                                                <AdminProductsManagement />
                                            }
                                        />
                                    </Route>
                                </Route>
                                <Route
                                    path={'live-orders'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <LiveOrders />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'PDFPreview'}
                                    element={<PDFPreview />}
                                />
                                <Route element={<MainFrame />}>
                                    <Route
                                        path={'quotations'}
                                        element={
                                            <PageWrapper>
                                                <ControlPagesWrapper
                                                    sidebarItems={
                                                        SIDEBAR_QUOTATION_NAVIGATION
                                                    }
                                                >
                                                    <Quotations />
                                                </ControlPagesWrapper>
                                            </PageWrapper>
                                        }
                                    />
                                    <Route
                                        path={'my-quotations'}
                                        element={
                                            <PageWrapper>
                                                <ControlPagesWrapper
                                                    sidebarItems={
                                                        SIDEBAR_QUOTATION_NAVIGATION
                                                    }
                                                >
                                                    <MyQuotations />
                                                </ControlPagesWrapper>
                                            </PageWrapper>
                                        }
                                    />
                                    <Route
                                        path={'quotation'}
                                        element={
                                            <Navigate to={'/quotations'} />
                                        }
                                    />
                                    <Route
                                        path={'quotation/:quoteId'}
                                        element={
                                            <PageWrapper>
                                                <ControlPagesWrapper
                                                    sidebarItems={
                                                        SIDEBAR_QUOTATION_NAVIGATION
                                                    }
                                                >
                                                    <Quotation />
                                                </ControlPagesWrapper>
                                            </PageWrapper>
                                        }
                                    />
                                    <Route
                                        path={'collections/:handle'}
                                        element={
                                            <PageWrapper>
                                                <CollectionPageWrapper>
                                                    <Collections />
                                                </CollectionPageWrapper>
                                            </PageWrapper>
                                        }
                                    />
                                    <Route
                                        path={
                                            'collections/:handle/products/:productHandle'
                                        }
                                        element={
                                            <PageWrapper>
                                                <ContentLayout>
                                                    <ProductPage />
                                                </ContentLayout>
                                            </PageWrapper>
                                        }
                                    />
                                </Route>
                            </Route>
                            <Route path={'*'} element={<Error404 />} />
                        </Route>
                    </Routes>
                </Provider>
            </StyledApp>
        </QueryClientProvider>
    );
}

export default App;
